/* tslint:disable */

declare var Object: any;
export interface WinnerHistoryInterface {
  "postContentId": number;
  "totalLike": number;
  "id"?: number;
}

export class WinnerHistory implements WinnerHistoryInterface {
  "postContentId": number;
  "totalLike": number;
  "id": number;
  constructor(data?: WinnerHistoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `WinnerHistory`.
   */
  public static getModelName() {
    return "WinnerHistory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of WinnerHistory for dynamic purposes.
  **/
  public static factory(data: WinnerHistoryInterface): WinnerHistory{
    return new WinnerHistory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'WinnerHistory',
      plural: 'WinnerHistories',
      path: 'WinnerHistories',
      properties: {
        "postContentId": {
          name: 'postContentId',
          type: 'number'
        },
        "totalLike": {
          name: 'totalLike',
          type: 'number'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/WinnerHistory.ts